import { Theme } from "@mui/material";

export function getCyclingLegendItems(palette: Theme["palette"]) {
  return [
    {
      id: "ftp",
      name: "FTP",
      primaryText: "Functional Threshold Power",
      color: palette.zones["4dp"].ftp.main,
    },
    {
      id: "map",
      name: "MAP",
      primaryText: "Maximal Aerobic Power",
      color: palette.zones["4dp"].map.main,
    },
    {
      id: "ac",
      name: "AC",
      primaryText: "Anaerobic Capacity",
      color: palette.zones["4dp"].ac.main,
    },
    { id: "nm", name: "NM", primaryText: "Neuromuscular", color: palette.zones["4dp"].nm.main },
  ];
}

export function getRunningLegendItems(palette: Theme["palette"]) {
  return [
    { id: "tp", name: "TP", primaryText: "Threshold Pace", color: palette.zones["4dp"].ftp.main },
    {
      id: "map",
      name: "MAP",
      primaryText: "Maximal Aerobic Power",
      color: palette.zones["4dp"].map.main,
    },
    {
      id: "ac",
      name: "AC",
      primaryText: "Anaerobic Capacity",
      color: palette.zones["4dp"].ac.main,
    },
  ];
}
